import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

export const SignupPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Sign Up</h1>
        <div className="bg-white rounded-lg shadow-md p-8 max-w-md mx-auto">
          <p className="text-gray-600 text-lg text-center">Sign up page - Coming soon</p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

